import { Analysis, UserAnalysis } from "containers/dashboard/types";

export function mapLabels(label: keyof (Analysis | UserAnalysis)) {
  switch (label) {
    case "下四分位":
      return "下四分位";
    case "上四分位":
      return "上四分位";
    case "最高":
      return "最高";
    case "平均":
      return "平均";
    case "學生":
      return "學生";
    case "最低":
      return "最低";
    default:
      return label
  }
}
